/* @ngInject */
function FormGroupStateDirective() {
    return {
        link: link,
        restrict: 'A'
    };

    function link(scope, element, attrs) {
        var states = [
            attrs.egFormGroupState + '.$dirty',
            attrs.egFormGroupState + '.$touched',
            attrs.egFormGroupState + '.$invalid'
        ];

        scope.$watchGroup(states, function(newValues) {
            var dirty = newValues[0];
            var touched = newValues[1];
            var invalid = newValues[2];
            if(dirty && touched && invalid){
                element.addClass('has-error');
                element.removeClass('has-success');
            } else if(dirty && touched){
                element.addClass('has-success');
                element.removeClass('has-error');
            } else {
                element.removeClass('has-success');
                element.removeClass('has-error');
            }
        });
    }
}

angular.module('egAngularUtils').directive('egFormGroupState', FormGroupStateDirective);